import {makeAutoObservable} from 'mobx';
import * as Api from '@/utils/api/api';
import * as antd from 'antd';

function getVerifySrc() {
  return `${Api.VerifySrc}?date=${new Date().getTime()}`;
}

class RegisterStore {
  username = '';
  verifyCode = '';
  password1 = '';
  password2 = '';
  verifyImg = getVerifySrc();
  usernameFocus = false;
  verifyCodeFocus = false;
  password1Focus = false;
  password2Focus = false;

  constructor() {
    makeAutoObservable(this)
  }

  refreshVerifyImg() {
    this.verifyImg = getVerifySrc();
  }

  /**
   * 注册
   */
  async doRegister() {
    try {
      const { username, password1, password2 } = this;

      if (!username) {
        antd.message.error('请输入用户名');
        return false;
      }
      // if (!this.verifyCode) {
      //   antd.message.error('请输入验证码');
      //   return false;
      // }
      if (!password1) {
        antd.message.error('请输入密码');
        return false;
      }
      if (password1 !== password2) {
        antd.message.error('两次输入的密码不一致');
        return false;
      }

      await Api.register({
        username,
        password: password1
      });

      return true;
    } catch (error) {
      return false;
    }
  }
}

const store = new RegisterStore();

export default store;
